//getarticles.js
import { db } from '../../firebase';
import { sdgs, slug } from '../../data';

import { ref, query, child, orderByChild, get, limitToLast, limitToFirst } from 'firebase/database';

const fetch = (mostViewedPosts) => {
  return new Promise((y, n) => {
    get(mostViewedPosts)
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());
          y({ data: Object.values(snapshot.val()) });
        } else {
          console.log('No data available');
          y({ data: null });
        }
      })
      .catch((error) => {
        //console.error(error);
        y({ data: null, error });
      });
  });
};

const fetch2 = (mostViewedPosts) => {
  return new Promise((y, n) => {
    get(mostViewedPosts)
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());
          y(snapshot.val());
        } else {
          console.log('No data available');
          y({ data: null });
        }
      })
      .catch((error) => {
        //console.error(error);
        y({ data: null, error });
      });
  });
};

export const getArticle = ({ lang, key }) => {
  /*http://localhost:4000/database/monarch-24-default-rtdb/data/articlesList/-Nouaa4LuLeUptBvtxU-*/
  //const mostViewedPosts =child(ref(db, `/articlesList/${key}`))
  const dbRef = ref(db);
  const mostViewedPosts = child(dbRef, `articlesList/${key}`);

  //const mostViewedPosts = query(ref(db, `/recent/all`), limitToLast(3));
  return new Promise((y, n) => {
    fetch2(mostViewedPosts)
      .then((c) => {
        if (c?.origin_lang == lang) {
          y(c);
        } else {
          //get translated version
          y({ data: null });
        }
      })
      .catch((e) => {
        y({ data: null });
      });
  });
};

export const getTop5Articles = ({ lang }) => {
  const mostViewedPosts = query(ref(db, `/recent/all`), limitToLast(5));
  return fetch(mostViewedPosts);
};

export const getBottom3Articles = ({ lang }) => {
  const mostViewedPosts = query(ref(db, `/recent/all`), limitToFirst(5));
  return fetch(mostViewedPosts);
};
//getTop15Articles
export const getTop15Articles = ({ lang }) => {
  const mostViewedPosts = query(ref(db, `/recent/all`), limitToLast(15));
  return fetch(mostViewedPosts);
};

export const getMoreArticles = ({ lang, sdg }) => {
  const mostViewedPosts = query(ref(db, `/recent/all`), orderByChild('postedOn'));
  return fetch(mostViewedPosts);
};

//by sdg

export const getTop21SdgArticles = ({ sdg }) => {
  console.log(`/recent/${slug(sdg)}`, sdg);
  const mostViewedPosts = query(ref(db, `/recent/${slug(sdg)}`), limitToLast(21));
  return fetch(mostViewedPosts);
};
export const getMoreSdgArticles = ({ lang, sdg }) => {
  const mostViewedPosts = query(ref(db, `/recent/${slug(sdg)}`), orderByChild('postedOn'));
  return fetch(mostViewedPosts);
};
